export class RequestPincode {
    UserName: string;
    IsSendByEmail: boolean;
    AdminReset?: boolean;
}